// extracted by mini-css-extract-plugin
export default {"container":"container--qGuwZE98rLKxLy1AyiPX","title":"title--ODWZEKCkmbROVTq_DM8S","text":"text--qanQfbQySeNdimjnLLdE"};